const ON_CHANGE = 'search//ON_CHANGE'
const TYPE_CHANGE = 'search//TYPE_CHANGE'
const RESET = 'search//RESET'

export {
  ON_CHANGE,
  TYPE_CHANGE,
  RESET
}
